import React from 'react';
import {List} from 'immutable';
import {Plugins, Atom, type ClassesList} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const SliderNav = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const slideClasses = ['w-slider-nav'];
    if (context.get('invert')) {
      slideClasses.push('w-slider-nav-invert');
    }
    if (context.get('shadow')) {
      slideClasses.push('w-shadow');
    }
    if (context.get('round')) {
      slideClasses.push('w-round');
    }
    if (context.get('numbers')) {
      slideClasses.push('w-num');
    }
    const navClasses = classes.concat(
      List<string>(slideClasses)
    ) as ClassesList;
    return (
      <div {...generateAttributes(attributes, navClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Slide Nav',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
  },
  render: SliderNav,
  fields: {children: TListOfElement},
});

export default config;
